var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#DCF0FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.23076,
    cy: 11.0768,
    r: 0.461538,
    fill: "#001F3B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.23076,
    cy: 12.923,
    r: 0.461538,
    fill: "#001F3B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.23076,
    cy: 14.7692,
    r: 0.461538,
    fill: "#001F3B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.077,
    cy: 11.0768,
    r: 0.461538,
    fill: "#001F3B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.077,
    cy: 12.923,
    r: 0.461538,
    fill: "#001F3B"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.077,
    cy: 14.7692,
    r: 0.461538,
    fill: "#001F3B"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9231,
    cy: 11.0768,
    r: 0.461538,
    fill: "#001F3B"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9231,
    cy: 12.923,
    r: 0.461538,
    fill: "#001F3B"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9231,
    cy: 14.7692,
    r: 0.461538,
    fill: "#001F3B"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.7692,
    cy: 11.0768,
    r: 0.461538,
    fill: "#001F3B"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.7692,
    cy: 12.923,
    r: 0.461538,
    fill: "#001F3B"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.7692,
    cy: 14.7692,
    r: 0.461538,
    fill: "#001F3B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 7.2V7.7H14.6667H16.6667C17.1767 7.7 17.5 8.06259 17.5 8.4V16.8C17.5 17.1374 17.1767 17.5 16.6667 17.5H7.33333C6.82329 17.5 6.5 17.1374 6.5 16.8V8.4C6.5 8.06259 6.82329 7.7 7.33333 7.7H9.33333H9.83333V7.2V6.5H10.1667V7.2V7.7H10.6667H13.3333H13.8333V7.2V6.5H14.1667V7.2ZM6.83333 16.8V17.3H7.33333H16.668H17.1681L17.168 16.7999L17.1667 8.4V8.39992L16.1667 8.4V8.40008V8.5H7.33333H6.83333V9V16.8Z",
    fill: "#001F3B",
    stroke: "#001F3B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCCalendar);
export default __webpack_public_path__ + "static/media/c-calendar.8dd017a6c7b2625c29f9e318d634f735.svg";
export { ForwardRef as ReactComponent };